import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import BasicModalWindow from '../../components/BasicModalWIndow'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import { addNewIssue, updateIssue } from './issuesSlice'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import IssuesApp, { IIssuesModal, issuesTypesList } from './IssuesApp'
import ResolveIssue from './ResolveIssue'
import { createOrUpdateElementData } from '../../components/Form/formsSlice'
import ItemsApp from '../items/ItemsApp'
import { addNewItem, updateItem, useReturnAllItems } from '../items/itemsSlice'
import { handleRequestError } from '../../services/api'
import { useReturnCurrentUser } from '../user/userSlice'
import { IDynamicForm } from '../../components/Form/DynamicForm'
import CreateNewIssue from './CreateNewIssue'
import { useLocation, useMatch } from 'react-router-dom'

interface IProps {
    shown: boolean,
    itemId?: number,
    issueId?: number,
    handleClose: () => void,
    resolveIssue?: boolean,
    executeAfterCreate?: (issue: IIssuesModal) => void,
}

export default function NewIssueModal(props: IProps) {

    const dispatch = useDispatch()

    const { shown, resolveIssue, itemId, issueId, executeAfterCreate } = props

    const isItemsViewPage = useMatch('/panel/items/view/:id')

    const currentUser = useReturnCurrentUser()

    const itemsApp = new ItemsApp()

    const handleClose = () => {
        props.handleClose()

    }

    const doAfterCreate = (issue: IIssuesModal) => {
        dispatch(addNewIssue(issue))
        handleClose()

        if (isItemsViewPage){
            window.location.reload()
        }
    }

    const afterSuccess = () => {
        handleClose()

        if (isItemsViewPage){
            window.location.reload()
        }
    }

    const advancedAfterSuccess = (item: IAxiosDefaultDataObject) => {
        const issue: IIssuesModal = (item as IIssuesModal)

        if (executeAfterCreate){
            executeAfterCreate(issue)
        }
        
        /**
         * Update item
         */
        if (issue.item_id){
            itemsApp.singleInstanceDetails(issue.item_id)
                .then(response => {
                    dispatch(updateItem(response.data))
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }

    return(
        <BasicModalWindow
            shown={shown}
            title={resolveIssue ? "Resolve Issue" : "Create new issue"}
            message=""
            size="fullscreen"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
            pageOverlayStyle
        >
            {resolveIssue ? (
                <ResolveIssue hidePageHeadSection={true} customId={issueId} afterSuccess={afterSuccess} noRedirect={true} advancedAfterSuccess={advancedAfterSuccess} />
            ) : (
                <CreateNewIssue itemId={itemId} doAfterCreate={doAfterCreate} />
            )}
        </BasicModalWindow>
    )
}

function NewIssueModalOld(props: IProps) {

    const dispatch = useDispatch()

    const { shown, resolveIssue, itemId, issueId } = props

    const issuesApp = new IssuesApp()
    const itemsApp = new ItemsApp()

    const currentUser = useReturnCurrentUser()

    const staffForm: IDynamicForm = {
        name: "issues_form",
        elements: [
            {
                id: issuesApp.elemPrefix + "item_id",
                xs: 6,
                type: "DynamicSelect",
                label: "Item",
                fullWidth: true,
                itemsList: useReturnAllItems,
                modelTitleParam: "title",
                appClass: new ItemsApp(),
                addNewItem: addNewItem,
            },
            {
                id: issuesApp.elemPrefix + "issue_type",
                xs: 6,
                type: "Select",
                label: "Type",
                fullWidth: true,
                items: issuesTypesList
            },
            {
                id: issuesApp.elemPrefix + "description",
                xs: 12,
                type: "BlockEditor",
                label: "Description",
                fullWidth: true,
            },
            {
                id: issuesApp.elemPrefix + "timestamp",
                xs: 12,
                type: "DateAndTime",
                label: "Timestamp",
                fullWidth: true,
                // defaultValue: new Date()
            },
        ]
    }

    const handleClose = () => {
        props.handleClose()
    }

    const updateIssue = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => {
        dispatch(addNewIssue((item as IIssuesModal)))
    }

    const afterSuccess = () => {
        handleClose()
    }

    const advancedAfterSuccess = (item: IAxiosDefaultDataObject) => {
        const issue: IIssuesModal = (item as IIssuesModal)
        
        /**
         * Update item
         */
        if (issue.item_id){
            itemsApp.singleInstanceDetails(issue.item_id)
                .then(response => {
                    dispatch(updateItem(response.data))
                })
                .catch(error => {
                    handleRequestError(error, dispatch)
                })
        }
    }

    useEffect(() => {
        dispatch(createOrUpdateElementData({
            name: "issues_item_id",
            value: itemId
        }))
    }, [itemId])

    return(
        <BasicModalWindow
            shown={shown}
            title={resolveIssue ? "Resolve Issue" : "Create new issue"}
            message=""
            size="md"
            showHeader
            handleClose={handleClose}
            actionButtons={[
                {
                    label: "Close",
                    handleClose: true,
                    color: "error"
                }
            ]}
            pageOverlayStyle
        >
            {resolveIssue ? (
                <ResolveIssue hidePageHeadSection={true} customId={issueId} afterSuccess={afterSuccess} noRedirect={true} advancedAfterSuccess={advancedAfterSuccess} />
            ) : (
                <AdminDynamicCreateOrUpdatePage 
                    updateItem={updateIssue}
                    customPageName="issues"
                    hidePageHeadBox={true}
                    forceCreatePage={true}
                    afterSuccess={afterSuccess}
                    noRedirect={true}
                    advancedAfterSuccess={advancedAfterSuccess}
                    customForm={!currentUser.is_superuser ? staffForm : undefined}
                />
            )}
        </BasicModalWindow>
    )
}